import(/* webpackMode: "eager", webpackExports: ["AuthErrors"] */ "/app/apps/web/src/app/[locale]/(auth)/login/components/auth-errors.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginWithEmailForm"] */ "/app/apps/web/src/app/[locale]/(auth)/login/components/login-email-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginWithOIDC"] */ "/app/apps/web/src/app/[locale]/(auth)/login/components/login-with-oidc.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SSOProvider"] */ "/app/apps/web/src/app/[locale]/(auth)/login/components/sso-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
